import { formatDate } from '@angular/common';
import { Inject, Injectable, Optional } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class UtcDateAdapter extends NativeDateAdapter {
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
    super(dateLocale);
  }

  getDayOfWeekNames(_style: 'long' | 'short' | 'narrow'): string[] {
    return [
      $localize`:@@material.utcDateAdapter.txtSun:Sun`,
      $localize`:@@material.utcDateAdapter.txtMon:Mon`,
      $localize`:@@material.utcDateAdapter.txtTue:Tue`,
      $localize`:@@material.utcDateAdapter.txtWed:Wed`,
      $localize`:@@material.utcDateAdapter.txtThu:Thu`,
      $localize`:@@material.utcDateAdapter.txtFri:Fri`,
      $localize`:@@material.utcDateAdapter.txtSat:Sat`,
    ];
  }

  format(date: Date, displayFormat: string): string {
    if (displayFormat === 'input') {
      return formatDate(date, 'dd-MM-yyyy', this.locale);
    }

    if (displayFormat === 'input-short') {
      return formatDate(date, 'dd-MM-yy', this.locale);
    }

    if (displayFormat === 'header') {
      return formatDate(date, 'MMM yyyy', this.locale);
    }

    return date.toDateString();
  }
}
